// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export const AdminUser = __t.object("AdminUser", {
  identity: __t.identity(),
});
export type AdminUser = __Infer<typeof AdminUser>;

export const Character = __t.object("Character", {
  characterId: __t.u64(),
  userId: __t.u64(),
  identity: __t.identity(),
  regionId: __t.u64(),
  treeId: __t.u64(),
  segmentId: __t.u64(),
  s: __t.f64(),
  theta: __t.f64(),
  r: __t.f64(),
  poseUpdatedAt: __t.timestamp(),
  spawnedAt: __t.timestamp(),
});
export type Character = __Infer<typeof Character>;

export const CharacterPose = __t.object("CharacterPose", {
  identity: __t.identity(),
  regionId: __t.u64(),
  treeId: __t.u64(),
  segmentId: __t.u64(),
  s: __t.f64(),
  theta: __t.f64(),
  r: __t.f64(),
  updatedAt: __t.timestamp(),
});
export type CharacterPose = __Infer<typeof CharacterPose>;

export const OnlineUser = __t.object("OnlineUser", {
  identity: __t.identity(),
  userId: __t.u64(),
  name: __t.option(__t.string()),
});
export type OnlineUser = __Infer<typeof OnlineUser>;

export const ReducerResult = __t.object("ReducerResult", {
  resultId: __t.u64(),
  correlationId: __t.string(),
  reducerName: __t.string(),
  status: __t.string(),
  message: __t.string(),
  details: __t.string(),
  completedAt: __t.timestamp(),
});
export type ReducerResult = __Infer<typeof ReducerResult>;

export const Region = __t.object("Region", {
  regionId: __t.u64(),
  name: __t.string(),
  originX: __t.f64(),
  originY: __t.f64(),
  originZ: __t.f64(),
  createdAt: __t.timestamp(),
});
export type Region = __Infer<typeof Region>;

export const Segment = __t.object("Segment", {
  segmentId: __t.u64(),
  regionId: __t.u64(),
  treeId: __t.u64(),
  parentSegmentId: __t.u64(),
  attachS: __t.f64(),
  attachTheta: __t.f64(),
  p0X: __t.f64(),
  p0Y: __t.f64(),
  p0Z: __t.f64(),
  p1X: __t.f64(),
  p1Y: __t.f64(),
  p1Z: __t.f64(),
  p2X: __t.f64(),
  p2Y: __t.f64(),
  p2Z: __t.f64(),
  p3X: __t.f64(),
  p3Y: __t.f64(),
  p3Z: __t.f64(),
  length: __t.f64(),
  radiusBase: __t.f64(),
  radiusTip: __t.f64(),
});
export type Segment = __Infer<typeof Segment>;

export const SegmentPayload = __t.object("SegmentPayload", {
  parentLocalId: __t.i32(),
  attachS: __t.f64(),
  attachTheta: __t.f64(),
  p0X: __t.f64(),
  p0Y: __t.f64(),
  p0Z: __t.f64(),
  p1X: __t.f64(),
  p1Y: __t.f64(),
  p1Z: __t.f64(),
  p2X: __t.f64(),
  p2Y: __t.f64(),
  p2Z: __t.f64(),
  p3X: __t.f64(),
  p3Y: __t.f64(),
  p3Z: __t.f64(),
  length: __t.f64(),
  radiusBase: __t.f64(),
  radiusTip: __t.f64(),
});
export type SegmentPayload = __Infer<typeof SegmentPayload>;

export const Tree = __t.object("Tree", {
  treeId: __t.u64(),
  regionId: __t.u64(),
  archetypeId: __t.string(),
  archetypeSeed: __t.u64(),
  generatorVersion: __t.string(),
  positionX: __t.f64(),
  positionY: __t.f64(),
  positionZ: __t.f64(),
  rotationY: __t.f64(),
  deployedAt: __t.timestamp(),
  rootSegmentId: __t.u64(),
});
export type Tree = __Infer<typeof Tree>;

export const User = __t.object("User", {
  identity: __t.identity(),
  userId: __t.u64(),
  name: __t.option(__t.string()),
  online: __t.bool(),
  lastLogin: __t.timestamp(),
  lastLogout: __t.option(__t.timestamp()),
  createdAt: __t.timestamp(),
  isAdmin: __t.bool(),
  isBanned: __t.bool(),
  banStarted: __t.option(__t.timestamp()),
  banReason: __t.option(__t.string()),
});
export type User = __Infer<typeof User>;

